/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2018 Adobe
 *  All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/
import getConfig from '../../../config';
export const HOME_TAB = 'HOME_TAB';
export const LEARN_TAB = 'LEARN_TAB';
export const DISCOVER_TAB = 'DISCOVER_TAB';
export const YOUR_WORK_TAB = 'YOUR_WORK_TAB';
export const APPS_TAB = 'APPS_TAB';
export const SEARCH_TAB = 'SEARCH_TAB';
export const LIBRARIES_TAB = 'LIBRARIES_TAB';
export const STOCK_MP_TAB = 'STOCK_MP_TAB';

type LinkItem = {
	title: string;
	tab: string;
	path?: string;
	url?: string;
};

export const linksLearnEntitle: Array<LinkItem> = [
	{
		title: 'app.navtab.home',
		tab: HOME_TAB,
		path: '/cc',
	},
	{
		title: 'app.navtab.apps',
		tab: APPS_TAB,
		path: '/apps',
	},
	{
		title: 'app.navtab.file',
		tab: YOUR_WORK_TAB,
		url: getConfig('CC_ASSETS_URL'),
	},
	{
		title: 'app.navtab.discover',
		tab: DISCOVER_TAB,
		path: '/cc/discover',
	},
	{
		title: 'app.navtab.libraries',
		tab: LIBRARIES_TAB,
		path: '/cc/libraries',
	},
];

export const linksNoLearnEntitle: Array<LinkItem> = [
	{
		title: 'app.navtab.home',
		tab: HOME_TAB,
		path: '/cc',
	},
	{
		title: 'app.navtab.apps',
		tab: APPS_TAB,
		path: '/apps',
	},
	{
		title: 'app.navtab.file',
		tab: YOUR_WORK_TAB,
		url: getConfig('CC_ASSETS_URL'),
	},
	{
		title: 'app.navtab.discover',
		tab: DISCOVER_TAB,
		path: '/cc/discover',
	},
];
